export enum Actors {
  MANAGER = 'MANAGER',
  IDEATOR = 'IDEATOR',
}
